import React, { useState, useRef, useEffect } from 'react';
import '../CSS/Event.css'; // Import your CSS file for styling

const technicalEvents = [
  { name: "Project Presentation", description: "Present your innovative ideas with real-time applications.", 
    rules:[
    " Maximum 3 Members  per Team",
    " Individual Registration",
    " Timing : 10 minutes",
  ],
  venue:[
    "DEPARTMENT : ELECTRONICS AND COMMUNICATION  ENGINEERING",
    "VENUE : APJ ABDUL KALAM BLOCK ,Ground FLOOR, Microprocessor Lab",
    "Maximum 5 mins for explanation followed by queries from judge",
    "DATE : 17.04.2025",
  ],
  phone: "9363558391"},
  { name: "Paper Presentation", description: "Showcase your research and technical knowledge through papers.", 
    rules:[
      "No. Of Member Per Team: Up to 3 ",
      " Individual Registration",
      " Time Per Presentation: 10 minutes",
      "Participants should register in only one team.",
      "No interchange of member is allowed. "
    ],
    venue:[
      "DEPARTMENT : ELECTRONICS AND COMMUNICATION  ENGINEERING",
      "Venue: APJ Abdul Kalam Block, Ground floor, Computer Lab",
      "DATE : 17.04.2025",
    ],
    phone: "8825677590"
  },
  { name: "Workshop – Embedded System & Design", description: "Hands-on session on embedded systems and IoT." , 
    rules:[
      
      " Individual Registration",
    
    ],
    venue:[
      "DEPARTMENT : ELECTRONICS AND COMMUNICATION  ENGINEERING",
      "VENUE : APJ ABDUL KALAM BLOCK ,First FLOOR",
      "DATE : 17.04.2025",
    ]
  },
  { name: "Circuitrix", description: "Exciting circuit-based challenges to test your skills.", 
    rules:[
      " Maximum 3 Members  per Team",
      " Individual Registration",
      " ANY FORM OF UNWANTED ACTIVITY WILL RESULT IN IMMEDIATE DISQUALIFICATION. ",
      " 2 Rounds :-> 1st Round - 30 mins , -> 2nd Round - 45 mins",
    ],
    venue:[
      "DEPARTMENT : ELECTRONICS AND COMMUNICATION  ENGINEERING",
      "VENUE : APJ ABDUL KALAM BLOCK ,GROUND FLOOR",
      "DATE : 17.04.2025",
    ],
    phone: "6379499254"
   }
];

const nonTechnicalEvents = [
  { name: "Connection", description: "Fun-filled activity connecting clues and concepts.", 
     rules:[
    " Maximum 3 Members  per Team",
    " Individual Registration",
    " Find the songs"
  ],
  venue:[
    "DEPARTMENT : ELECTRONICS AND COMMUNICATION  ENGINEERING",
    "VENUE : APJ ABDUL KALAM BLOCK ,First FLOOR",
    "DATE : 17.04.2025",
  ],
  phone: "9585758878"},
  { name: "Free Fire", description: "Live tic-tac-toe game with real participants!" , 
    rules:[
      " Must 4 members per team",
      " Individual Registration",
      "Need mobile phone with internet"
    ],
    venue:[
      "DEPARTMENT : ELECTRONICS AND COMMUNICATION  ENGINEERING",
      "VENUE : APJ ABDUL KALAM BLOCK ,First FLOOR",
      "DATE : 17.04.2025",
    ],
    phone: "9698098384"
  },
  { name: "Memory Test", description: "Test your memory under pressure!", 
    rules:[
      " Individual Game",
      " Individual Registration",
      " No of .image will show in 15 seconds in Projector  with in this much  time who are maximum find  "
    ],
    venue:[
      "DEPARTMENT : ELECTRONICS AND COMMUNICATION  ENGINEERING",
      "VENUE : APJ ABDUL KALAM BLOCK ,First FLOOR",
      "DATE : 17.04.2025",
    ],
    phone: "6374754153"
   },
  { name: "Quiz", description: "Compete in a tech and general knowledge quiz!", 
    rules:[
      "Individual Game",
      " Individual Registration",
      "2 Rounds :-> 1st Round - 20 mins , -> 2nd Round - 20 mins",
      " General question "
    ],
    venue:[
      "DEPARTMENT : ELECTRONICS AND COMMUNICATION  ENGINEERING",
      "VENUE : APJ ABDUL KALAM BLOCK ,First FLOOR",
      "DATE : 17.04.2025",
    ],
    phone: "9597885227"
   },
  { name: "Pick & Speak", description: "Speak on surprise topics with confidence.",
    rules:[
      "Individual Game",
      " Individual Registration",
      "General Topic  you can speak maximum 2 Minutes (Any language)"
    ],
    venue:[
      "DEPARTMENT : ELECTRONICS AND COMMUNICATION  ENGINEERING",
      "VENUE : APJ ABDUL KALAM BLOCK ,First FLOOR",
      "DATE : 17.04.2025",
    ],
    phone: "-"
   }
];

const EventsSection = () => {
  const [selectedEvent, setSelectedEvent] = useState(null);
  const detailRef = useRef(null);

  const handleClick = (event) => {
    setSelectedEvent(event);
  };

  useEffect(() => {
    if (selectedEvent && detailRef.current) {
      // Scroll 150px above the detail section
      const offsetTop = detailRef.current.offsetTop - 150;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      });
    }
  }, [selectedEvent]);

  return (
    <section className="events-section" id="events">
      <h2>Explore Our Events</h2>

      <h3>Click Event Name for More Details</h3>

      <div className="event-lists">
        <div>
          <h3>Technical Events</h3>
          <ul>
            {technicalEvents.map((event, index) => (
              <li key={index} onClick={() => handleClick(event)}>
                {event.name}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3>Non-Technical Events</h3>
          <ul>
            {nonTechnicalEvents.map((event, index) => (
              <li key={index} onClick={() => handleClick(event)}>
                {event.name}
              </li>
            ))}
          </ul>
        
        </div>
      </div>

      {selectedEvent && (
        <div className="event-detail" ref={detailRef}>
          <h4>{selectedEvent.name}</h4>
          <p>{selectedEvent.description}</p>
          {selectedEvent.rules && (
  <>
    <h3>Rules:</h3>
    <ul className="event-rules">
      {selectedEvent.rules.map((rule, idx) => (
        <li key={idx}>{rule}</li>
      ))}
    </ul>
    <h3>Venue:</h3>
    <ul className="event-rules">
      {selectedEvent.venue.map((venue, idx) => (
        <li key={idx}>{venue}</li>
      ))}
    </ul>
    {selectedEvent.phone && (
  <h6>
   <p> Contact: <a href={`tel:${selectedEvent.phone}`}>{selectedEvent.phone}</a> </p>
  </h6>
)}

  </>
  
)}
        </div>
      )}
    </section>
  );
};

export default EventsSection;
